import * as React from "react";
const SvgCameraDrag = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M15.6663 14.5667H11.6663V18.5667H10.333V14.5667H6.33301V13.2333H10.333V9.23334H11.6663V13.2333H15.6663V14.5667Z",
	fill: "#626C77"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M18.7208 6.27775H3.67923C2.66324 6.27775 1.83961 7.25278 1.83961 8.45553V19.3444C1.83961 20.5472 2.66324 21.5222 3.67923 21.5222H18.7208C19.7368 21.5222 20.5604 20.5472 20.5604 19.3444V8.45553C20.5604 7.25278 19.7368 6.27775 18.7208 6.27775ZM3.67923 4.09998C1.64725 4.09998 0 6.05002 0 8.45553V19.3444C0 21.7499 1.64725 23.7 3.67923 23.7H18.7208C20.7528 23.7 22.4 21.7499 22.4 19.3444V8.45553C22.4 6.05002 20.7528 4.09998 18.7208 4.09998H3.67923Z",
	fill: "#007CFF"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M26.1999 9.29637C26.1999 9.0395 25.9606 8.87438 25.7609 8.99344L21.5609 11.4968C21.462 11.5558 21.3999 11.6725 21.3999 11.7998V16.1197C21.3999 16.2493 21.4643 16.3679 21.5662 16.4257L25.7662 18.8098C25.9656 18.9231 26.1999 18.7578 26.1999 18.5038V9.29637ZM24.9267 7.17581C26.3249 6.34242 27.9999 7.49824 27.9999 9.29637V18.5038C27.9999 20.2813 26.3597 21.4384 24.9636 20.6459L20.7636 18.2617C20.0506 17.857 22.4016 17.4 20.9999 16.1197V11.7998C22.4014 9.70002 20.0341 10.092 20.7267 9.67919L24.9267 7.17581Z",
	fill: "#007CFF"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M25.1631 22.3143C25.3511 22.2494 25.4827 22.0793 25.4984 21.8811C25.5141 21.6829 25.4109 21.4942 25.2355 21.4006L12.2355 14.459C12.0595 14.365 11.8444 14.3846 11.6883 14.509C11.5323 14.6334 11.4651 14.8387 11.5175 15.0313L15.3075 28.9615C15.3587 29.1497 15.5146 29.2909 15.7069 29.3233C15.8992 29.3557 16.0928 29.2733 16.2028 29.1123L18.6608 25.5144L21.6364 29.2134C21.8061 29.4243 22.1127 29.4619 22.3283 29.2983L23.8633 28.1336C23.9709 28.0519 24.0409 27.9302 24.0573 27.7962C24.0738 27.6621 24.0353 27.5271 23.9506 27.4218L20.9983 23.7518L25.1631 22.3143Z",
	fill: "white",
	stroke: "black",
	strokeLinejoin: "round"
}));
export default SvgCameraDrag;
